import React from 'react';
import { OverviewCommon } from 'components/common';
import { invoiceItems } from 'constant';
import useAuthContext from 'stores/auth-context';
import { filterOverviewMenuByPermission } from 'utils/permission';
const InvoicePage: React.FC = () => {
  const { profile } = useAuthContext();
  return <OverviewCommon items={filterOverviewMenuByPermission(invoiceItems, profile?.data?.permissionKeys || [])} />;
};

export default InvoicePage;
